import React, { useMemo, useState } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import { CustomerMasterData } from "types/models/customerMaster/CustomerMasterApp";

interface CustomerTableProps {
  customer: CustomerMasterData[];
}

type Order = "asc" | "desc";

const CustomerTable: React.FC<CustomerTableProps> = ({ customer }) => {
  const [order, setOrder] = useState<Order>("asc");
  const [orderBy, setOrderBy] = useState<keyof CustomerMasterData>("contact_name");

  const handleSortRequest = (property: keyof CustomerMasterData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedCustomer = useMemo(() => {
    return [...customer].sort((a, b) => {
      const aVal = a[orderBy];
      const bVal = b[orderBy];

      if (aVal == null && bVal == null) return 0;
      if (aVal == null) return order === "asc" ? -1 : 1;
      if (bVal == null) return order === "asc" ? 1 : -1;

      return String(aVal).localeCompare(String(bVal)) * (order === "asc" ? 1 : -1);
    });
  }, [customer, order, orderBy]);

  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading order={order} orderBy={orderBy} onSort={handleSortRequest} />
        </TableHead>
        <TableBody>
          {sortedCustomer.map((data) => (
            <TableItem
              customer={data}
              key={data.contact_number || data.contact_email}
            />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default CustomerTable;
